module.exports = __webpack_public_path__ + "img/227.fd32aea0.jpg";